import { render, staticRenderFns } from "./tech.vue?vue&type=template&id=00c11b1c&scoped=true&"
import script from "./tech.vue?vue&type=script&lang=js&"
export * from "./tech.vue?vue&type=script&lang=js&"
import style0 from "./tech.vue?vue&type=style&index=0&id=00c11b1c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c11b1c",
  null
  
)

export default component.exports